import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Service, ServiceCreate } from '../../models';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ServiceService {

  constructor(
    private http: HttpClient
  ) { }

  public getAll() {
    return this.http.get<{
      code: string;
      data: Array<Service>
    }>(`${environment.host}/organization/service/`);
  }

  public searchService(text: string) {
    return this.http.get<{
      code: string;
      data: Array<Service>
    }>(`${environment.host}/organization/service/?search=${text}`);
  }

  public getById(id: number) {
    return this.http.get<{
      code: string;
      data: Service
    }>(`${environment.host}/organization/service/${id}/`);
  }

  public create(data: ServiceCreate) {
    data.price = Number(data.price);
    data.duration = Number(data.duration);

    return this.http.post<{
      code: string;
      data: Service,
      message: string
    }>(`${environment.host}/organization/service/`, data);
  }

  public update(data: ServiceCreate, id: number) {
    data.price = Number(data.price);
    data.duration = Number(data.duration);

    return this.http.put<{
      code: string;
      data: Service,
      message: string
    }>(`${environment.host}/organization/service/${id}/`, data);
  }

  public delete(id: number) {
    return this.http.delete<{
      code: string;
      data: Service
    }>(`${environment.host}/organization/service/${id}/`);
  }
}
